import React from "react";
import LOGO from "../../assets/images/LOGO.png";
import Link from "react-scroll/modules/components/Link";
import { Flip, Fade } from "react-reveal";
const NavBar = () => {
  return (
    <div className="bg-[#ffffff] shadow-2xl sticky top-0 z-50 text-sm sm:text-md md:text-lg lg:text-xl xl:text-2xl">
      <div className="flex flex-row justify-center items-center p-1 w-full">
        <div className="flex flex-col justify-center items-center mx-2 xl:mx-4 2xl:mx-8 md:my-2">
          <Flip left>
            <Link activeClass="active" to="home" spy={true} smooth={true}>
              <img
                className="h-[55px] sm:h-[55px] cursor-pointer"
                src={LOGO}
                alt="LOGO"
              />
            </Link>
          </Flip>
          {/* <p className="font-['FuturaExtraBold'] text-[#00693A] text-sm md:text-lg text-center cursor-pointer">
            LEBANESE
          </p>
          <p className="font-['FuturaExtraBold'] text-[#00693A] text-sm md:text-lg text-center cursor-pointer xl:-mt-3">
            GREEN WAVE
          </p> */}
        </div>
        <div className="flex-1"></div>
        <Fade left>
          <div className="font-['FuturaMed'] m-2 lg:m-4 xl:m-6 2xl:m-8 text-[#00693A] cursor-pointer">
            <Link activeClass="active" to="home" spy={true} smooth={true}>
              Home
            </Link>
          </div>
          <div className="font-['FuturaMed'] m-2 lg:m-4 xl:m-6 2xl:m-8 text-[#00693A] cursor-pointer">
            <Link to="Reg" spy={true} smooth={true}>
              Registration
            </Link>
          </div>
          <div className="font-['FuturaMed'] m-2 lg:m-4 xl:m-6 2xl:m-8 text-[#00693A] cursor-pointer">
            <Link to="Evnt" spy={true} smooth={true}>
              Events
            </Link>
          </div>
          <div className="font-['FuturaMed'] m-2 lg:m-4 xl:m-6 2xl:m-8 text-[#00693A] cursor-pointer">
            <Link to="Contact" spy={true} smooth={true}>
              Contact
            </Link>
          </div>
        </Fade>
      </div>
    </div>
  );
};

export default NavBar;
